import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import OrderPlaced from '../components/OrderPlaced'
import { actionCreators } from '../actions'

const mapStateToProps = (state) => ({
  orderGroup: state.order.orderGroup, // gives our component access to state through props
  device: state.native.nativeAppInfo.device,
  cancelOrderDetails: state.order.cancelOrder,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(actionCreators, dispatch)

export default connect(mapStateToProps, mapDispatchToProps, undefined, {
  pure: false,
})(OrderPlaced)
